// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs-module__tabs__o-mUG","content":"Tabs-module__content__4kJCP","chevron":"Tabs-module__chevron__soJL0","icon":"Tabs-module__icon__XdKQ6"};